/* Apipet gift akcija — config: window.APGift (snippets/apipet-gift-akcija.liquid) */
(function () {
  'use strict';
  var CFG = window.APGift || {};
  var A = CFG.akcija;
  var ALL = (CFG.allIds || []).map(String);
  var PREFIX = 'bfp-';
  var busy = false, lastCart = null, lineOpen = {}, failed = {};

  function isActive() {
    if (!A) { return false; }
    var now = Date.now() / 1000;
    return now >= A.start && now <= A.end;
  }
  function isGiftLine(l) {
    return ALL.indexOf(String(l.variant_id)) > -1 || String(l.handle || '').indexOf(PREFIX) === 0;
  }
  function prop(l, k) { return l.properties && l.properties[k] != null ? String(l.properties[k]) : ''; }
  function tierAllowed(t) {
    var ids = [];
    t.options.forEach(function (o) { o.variants.forEach(function (v) { ids.push(String(v.id)); }); });
    return ids;
  }

  function fmt(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) { throw r; } return r.json(); });
  }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function refreshRebuy() {
    try {
      if (window.Rebuy && Rebuy.Cart && typeof Rebuy.Cart.fetchCart === 'function') { return Rebuy.Cart.fetchCart(); }
    } catch (e) {}
    return Promise.resolve();
  }
  function onCartPage() { return /^\/(([a-z]{2}(-[a-z]{2})?)\/)?cart\/?$/i.test(location.pathname); }

  /* guard */
  function planFix(cart) {
    var ops = [], adds = [];
    var active = isActive();
    var base = cart.total_price || 0;
    var seen = {};
    cart.items.forEach(function (l) {
      if (!isGiftLine(l)) { return; }
      if (!active) { ops.push({ id: l.key, quantity: 0 }); return; }
      var p = prop(l, '_bf_razred');
      var t = null;
      A.tiers.forEach(function (x) { if (String(x.prag) === p) { t = x; } });
      var ok = t && base >= t.prag && !seen[p] && tierAllowed(t).indexOf(String(l.variant_id)) > -1 && prop(l, '_bf_akcija') === A.handle;
      if (!ok) {
        ops.push({ id: l.key, quantity: 0 });
        return;
      }
      seen[p] = true;
      if (l.quantity !== 1) { ops.push({ id: l.key, quantity: 1 }); }
    });
    if (active) {
      A.tiers.forEach(function (t) {
        if (base < t.prag || seen[String(t.prag)]) { return; }
        var v = null;
        for (var i = t.options.length - 1; i >= 0 && !v; i--) {
          v = t.options[i].variants.filter(function (x) { return x.available && !failed[x.id]; })[0] || null;
        }
        if (!v) { return; }
        adds.push({ id: v.id, quantity: 1, properties: { _bf_razred: String(t.prag), _bf_akcija: A.handle } });
      });
    }
    return { ops: ops, adds: adds };
  }

  function check(force) {
    if (busy) { return; }
    getCart().then(function (cart) {
      var plan = planFix(cart);
      if (!plan.ops.length && !plan.adds.length) { lastCart = cart; render(); return force ? refreshRebuy() : null; }
      busy = true;
      var p = Promise.resolve(), added = false;
      plan.ops.forEach(function (op) { p = p.then(function () { return post('/cart/change.js', op); }); });
      if (plan.adds.length) {
        p = p.then(function () { return post('/cart/add.js', { items: plan.adds }).then(function () { added = true; }); })
          .catch(function () { plan.adds.forEach(function (a) { failed[a.id] = 1; }); });
      }
      return p.catch(function () {}).then(getCart).then(function (c) {
        lastCart = c; busy = false; render();
        if (onCartPage() && (plan.ops.length || added)) { location.reload(); return; }
        return refreshRebuy();
      });
    }).catch(function () { busy = false; });
  }

  /* odabir */
  function pick(t, variantId, btn) {
    if (busy || !lastCart || !isActive()) { return; }
    var cur = lastCart.items.filter(function (l) { return isGiftLine(l) && prop(l, '_bf_razred') === String(t.prag); })[0];
    if (cur && String(cur.variant_id) === String(variantId)) { return; }
    busy = true;
    if (btn && btn.parentNode) {
      [].forEach.call(btn.parentNode.children, function (x) { x.classList.remove('is-selected'); });
      btn.classList.add('is-selected', 'is-loading');
    }
    var p = cur ? post('/cart/change.js', { id: cur.key, quantity: 0 }) : Promise.resolve();
    p.then(function () {
      return post('/cart/add.js', { items: [{ id: variantId, quantity: 1, properties: { _bf_razred: String(t.prag), _bf_akcija: A.handle } }] });
    }).then(function () { lineOpen[A.tiers.indexOf(t)] = false; }, function () { failed[variantId] = 1; })
      .then(function () { busy = false; check(true); });
  }

  /* prikaz */
  var ICON_OK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function eur(c) { return (c % 100 === 0 ? String(c / 100) : (c / 100).toFixed(2).replace('.', ',')) + ' €'; }

  function barHTML(base) {
    var T = A.tiers, n = T.length, pct = 100, done = 0;
    for (var i = 0; i < n; i++) {
      if (base < T[i].prag) {
        var prev = i ? T[i - 1].prag : 0;
        pct = ((i + (base - prev) / (T[i].prag - prev)) / n) * 100;
        break;
      }
      done++;
    }
    var next = T[done];
    var h = '<div class="apg-bar"><div class="apg-bar__top"><b>' + esc(A.barTitle) + '</b><span>' + done + '/' + n + ' otključano</span></div>';
    h += '<div class="apg-track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '">';
    h += '<div class="apg-fill" style="width:' + Math.max(0, Math.min(100, pct)).toFixed(1) + '%"></div>';
    T.forEach(function (t, k) {
      h += '<span class="apg-stop' + (k < done ? ' is-done' : (k === done ? ' is-next' : '')) + '" style="left:' + (((k + 1) / n) * 100).toFixed(2) + '%"></span>';
    });
    h += '</div><p class="apg-bar__msg">' + (next
      ? 'Još <b>' + esc(fmt(next.prag - base)) + '</b> do poklona iznad ' + esc(eur(next.prag))
      : '<b>Svi pokloni su otključani</b>') + '</p>';
    if (A.ship > 0) {
      h += '<p class="apg-bar__ship' + (base >= A.ship ? ' is-ok' : '') + '">' + (base >= A.ship
        ? ICON_OK + 'Besplatna dostava (kućna adresa)'
        : 'Još ' + esc(fmt(A.ship - base)) + ' do besplatne dostave') + '</p>';
    }
    return h + '</div>';
  }

  /* kratka oznaka kao u kosarici (APRebuy.config.cart): prvi poznati problem, inace vrsta */
  function tagFor(v) {
    var C = (window.APRebuy && APRebuy.config && APRebuy.config.cart) || {}, P = C.problems || {}, S = C.species || {};
    var pr = [].concat(v.pr || []), za = [].concat(v.za || []);
    for (var i = 0; i < pr.length; i++) { if (P[pr[i]]) { return P[pr[i]]; } }
    if (za.length > 1) { return S.both || ''; }
    return za.length ? (S[za[0]] || '') : '';
  }

  function optsHTML(t, ti, line, locked) {
    var h = '<div class="apg-opts">';
    t.options.forEach(function (o) {
      o.variants.forEach(function (v) {
        if (!v.available) { return; }
        var sel = line && String(line.variant_id) === String(v.id);
        var main = o.name, sub = '';
        if (o.variants.length > 1 && o.opt === 'Proizvod') { main = v.label; sub = o.name; }
        else if (o.variants.length > 1) { sub = v.label; }
        else if (v.label !== o.name) { main = o.name + ' ' + v.label; }
        if (v.rn) { main = v.rn; sub = tagFor(v); }
        h += '<button type="button" class="apg-opt' + (sel ? ' is-selected' : '') + '"' + (locked ? ' disabled' : '') +
          ' data-apg-tier="' + ti + '" data-apg-variant="' + v.id + '" aria-pressed="' + !!sel + '">';
        h += '<span class="apg-opt__img">' + (v.img ? '<img src="' + esc(v.img) + '" alt="" width="56" height="56" loading="lazy">' : '') +
          (sel ? '<span class="apg-opt__tick">' + ICON_OK + '</span>' : '') + '</span>';
        h += '<span class="apg-opt__n">' + esc(main) + '</span>';
        if (sub) { h += '<span class="apg-opt__v">' + esc(sub) + '</span>'; }
        if (v.rn && v.val > 0) { h += '<span class="apg-opt__p"><s>' + esc(fmt(v.val)) + '</s> 0 €</span>'; }
        h += '</button>';
      });
    });
    return h + '</div>';
  }

  function place(root, sel, node, after) {
    var anchor = root.querySelector(sel);
    if (!anchor) { return false; }
    if (after) {
      if (anchor.nextElementSibling !== node) { anchor.parentNode.insertBefore(node, anchor.nextSibling); }
    } else if (node.parentNode !== anchor) { anchor.appendChild(node); }
    return true;
  }

  var barEl = null, lastHTML = '';
  function render() {
    var root = document.getElementById('rebuy-cart');
    if (!root) { return; }
    var on = isActive() && lastCart && lastCart.item_count > 0;
    if (!on) {
      root.classList.remove('apg-on');
      if (barEl && barEl.parentNode) { barEl.parentNode.removeChild(barEl); }
      return;
    }
    if (!barEl) { barEl = document.createElement('div'); barEl.className = 'apg-host apg-host--bar'; }
    var bh = barHTML(lastCart.total_price || 0);
    if (bh !== lastHTML) { barEl.innerHTML = bh; lastHTML = bh; }
    root.classList.add('apg-on');
    place(root, '[data-rebuy-component="progress-bar"]', barEl, true) ||
      place(root, '[data-rebuy-cart-anchor="header"]', barEl, false);
    lineSkin(root);
  }

  /* linija poklona: Poklon iznad X € + Promijeni (odabir tog razreda u liniji) */
  function rebuyItems() {
    try { return Rebuy.SmartCart.items() || []; } catch (e) { return []; }
  }
  function lineSkin(root) {
    var items = rebuyItems();
    var lis = root.querySelectorAll('li.rebuy-cart__flyout-item');
    [].forEach.call(lis, function (li, i) {
      if (String(li.className).indexOf('product-' + PREFIX) === -1) { return; }
      var info = li.querySelector('.rebuy-cart__flyout-item-info');
      if (!info) { return; }
      var it = items[i];
      var ti = -1;
      if (it && String(li.className).indexOf('product-' + it.handle + ' ') > -1) {
        var p = prop(it, '_bf_razred');
        A.tiers.forEach(function (x, k) { if (String(x.prag) === p) { ti = k; } });
      }
      var open = ti > -1 && lineOpen[ti] === true;
      var key = ti + '|' + open + '|' + (it ? it.variant_id : '') + '|' + (busy ? 1 : 0);
      var box = info.querySelector(':scope > .apg-line');
      if (box && box.getAttribute('data-key') === key) { return; }
      if (!box) { box = document.createElement('div'); box.className = 'apg-line'; info.appendChild(box); }
      box.setAttribute('data-key', key);
      var h = '<span class="apg-line__lbl">' + (ti > -1 ? 'Poklon iznad ' + esc(eur(A.tiers[ti].prag)) : 'Poklon uz narudžbu') + '</span>';
      if (ti > -1) {
        h += '<button type="button" class="apg-line__chg" data-apg-line="' + ti + '">' + (open ? 'Zatvori' : 'Promijeni') + '</button>';
        if (open) { h += optsHTML(A.tiers[ti], ti, it, false); }
      }
      box.innerHTML = h;
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-apg-variant], [data-apg-line]');
    if (!t || !A) { return; }
    e.preventDefault(); e.stopPropagation();
    if (t.hasAttribute('data-apg-line')) {
      var li = +t.getAttribute('data-apg-line');
      lineOpen[li] = !lineOpen[li];
      var root = document.getElementById('rebuy-cart');
      if (root) { lineSkin(root); }
      return;
    }
    if (t.disabled) { return; }
    var tier = A.tiers[+t.getAttribute('data-apg-tier')];
    if (tier) { pick(tier, +t.getAttribute('data-apg-variant'), t); }
  }, true);

  /* PDP poklona nikad nije za kupca */
  if (/\/products\/bfp-/.test(location.pathname)) { location.replace('/'); }

  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(check, 250); }
  ['rebuy:cart.ready', 'rebuy:cart.change', 'rebuy:cart.add', 'rebuy:cart.update', 'rebuy:cart.remove', 'rebuy:smartcart.show']
    .forEach(function (n) { document.addEventListener(n, schedule); });

  var tries = 0;
  function hookPubsub() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    } else if (tries++ < 20) { setTimeout(hookPubsub, 500); }
  }

  /* Rebuy (Vue) zna iscrtati kosaricu iznova — vrati nase elemente */
  var mo = new MutationObserver(function () {
    if (!lastCart || !isActive()) { return; }
    var root = document.getElementById('rebuy-cart');
    if (!root) { return; }
    if ((barEl && !root.contains(barEl)) || !root.classList.contains('apg-on') ||
      root.querySelector('li.rebuy-cart__flyout-item[class*="product-' + PREFIX + '"] .rebuy-cart__flyout-item-info:not(:has(> .apg-line))')) {
      clearTimeout(mo.t); mo.t = setTimeout(render, 60);
    }
  });

  function init() {
    hookPubsub();
    check();
    if (A) { mo.observe(document.body, { childList: true, subtree: true }); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();